import React from "react";
import ChartContainer from "../chart-container";
import lang from "translations";
// import { LineChart, BarStackChart } from "components/commons";
import styles from "../dashboard-charts.module.scss";

const CheckInsChart = ({ ...props }) => {
  const data = props.mappedData;
  return (
    <ChartContainer
      title={lang.checkIns}
      {...props}
      empty={!data.total?.value}
      emptyText={lang.noCheckInsInDateRange}
      className={styles.roundedChartCard}
    >
      <div className={styles.checkInsValue}>{data.total?.value}</div>
      <span className={styles.checkInsChip}>{lang.new}</span>
      
      {/* <BarStackChart
        data={[
          {
            label: lang.new,
            value: data.total?.value,
            color: "#008D91",
          },
        ]}
      />
      <LineChart {...data.data} />
      */}
    </ChartContainer>
  );
};

export default CheckInsChart;
